import {React,useState} from 'react'
import './Somes.css'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
import Collapsible from 'react-collapsible';
const Iq2 = () => {
    return (
        <div className='container'>
                 <NavLink to='/category/Interview question/9'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Interview question/7'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'80px'}}>&lt;- Previous page </Button>
</NavLink>

<div>
<h1 class="h1"style={{float:'left'}}> Aptitude Questions</h1>
<h3 style={{float:'right'}}> Topics: <b>Odd man out series</b></h3>

</div>

<br /> <br /> <br /> <br />

<br />
<td>



<p class="pq">1) Complete the series 2, 5, 9, 19, 37.......</p>
<ol class="pointsu">
<li className='list'>76</li>
<li className='list'>74</li>
<li className='list'>75</li>
<li className='list'>None of these.</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(1)" trigger='Show Answer'> 
<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong></p>
<p>The second number is one more than twice the first,<br/>
2 x 2 +1 = 5</p>
<p>The third number is one less than twice the second,<br/>
5 x 2 -1 = 9</p>
<p>The fourth number is one more than twice the third,<br/>
9 x 2 +1 = 19</p>
<p>The fifth number is one less than twice the fourth. <br/>
19 x 2 - 1 = 37</p>
<p>Therefore, the sixth number is one more than twice the fifth. So, the missing number:<br/>
37 x 2 + 1 = 75. </p>
</div> </Collapsible>
<br />

<p class="pq">2) The next number of the sequence 0, 7, 26, 63......</p>
<ol class="pointsu">
<li className='list'>124</li>
<li className='list'>126</li>
<li className='list'>215</li>
<li className='list'>217</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(2)" trigger='Show Answer'> 
<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong></p>
<p>The terms of the given series are<br/>
(1<sup>3</sup> - 1) = 1 -1 = 0, <br/>
(2<sup>3</sup> - 1) = 8 - 1 = 7, <br/>
(3<sup>3</sup> - 1) = 27 - 1 = 26, <br/>
(4<sup>3</sup> -1) = 64 - 1 = 63.....</p>
So, the next term will be <br/>
5<sup>3</sup> - 1 = 125 - 1 = 124 <p></p>
</div> </Collapsible>
<br />

<p class="pq">3) In the following number series, a wrong number is given. Find out that number<br/>
8, 18, 40, 86, 178, 370, 752.</p>
<ol class="pointsu">
<li className='list'>18</li>
<li className='list'>178</li>
<li className='list'>370</li>
<li className='list'>40</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(3)" trigger='Show Answer'> 
<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong></p>
<p>The given sequence is </p>
<p>x 2 + 2 i.e. 8 x 2 + 2 = 16+2 = 18,<br/>
x 2 + 4 i.e. 18 x 2+ 4 = 36+4 = 40,<br/>
x 2 + 6 i.e. 40 x 2 + 6 = 80+6 = 86,<br/>
x 2 + 8 i.e. 86 x 2 + 8 = 172+8 = 180,<br/>
x 2 + 10 i.e. 180 x 2 + 10 = 360+10 = 370,<br/>
x 2 + 12 i.e. 370 x 2 + 12 = 740+12 = 752.</p>
<p>Hence, the number 178 is wrong, and it should be replaced by 180.</p>
</div> </Collapsible>
<br />

<p class="pq">4) Find out the missing number in the following sequence.<br/>
53, 44, 52,?, 51, 46.</p>
<ol class="pointsu">
<li className='list'>45
</li><li className='list'>61</li>
<li className='list'>44</li>
<li className='list'>62</li>
<li className='list'>43</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(4)" trigger='Show Answer'> 
<div id="workspace4"></div>
<div class="testanswer" id="answer4">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong></p>
<p>In the given series, there are two sequences:<br/>
53, 52, 51, and 44,?, 46</p>
<p>In the first sequence, each digit is decreased by 1<br/>
i.e. 53, 52, 51</p>
<p>In the second sequence, each digit is increased by 1<br/>
44, 45, 46</p>
<p>Therefore 45 is the missing number.</p>
</div> </Collapsible>
<br />

<p class="pq">5) Find out the wrong number in the series:<br/>
3, 8, 15, 24, 34, 48, 63</p>
<ol class="pointsu">
<li className='list'>15</li>
<li className='list'>24</li>
<li className='list'>34</li>
<li className='list'>48</li>
<li className='list'>63</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(5)" trigger='Show Answer'> 
<div id="workspace5"></div>
<div class="testanswer" id="answer5">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong></p>
<p>The differences between consecutive terms are respectively 5, 7, 9, 11, and 13.<br/>
So, 34 is the wrong number.</p>
</div> </Collapsible>
<br/>





<p class="pq">6) Find out the wrong number in the series:<br/>
125, 106, 88, 76, 65, 58, 53</p>
<ol class="pointsu">
<li className='list'>125</li>
<li className='list'>106</li>
<li className='list'>88</li>
<li className='list'>76</li>
<li className='list'>65</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(1)" trigger='Show Answer'> 
<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong></p>
<p>To get the next number in the given series go on subtracting prime numbers 19, 17, 13, 11, 7, and 5 from the numbers. <br/>
Like: 125 - 19 = 106<br/>
106 - 17 = 89<br/>
89 - 13 = 76<br/>
76 - 11 = 65<br/>
65 - 7 = 58<br/>
58 - 5 = 53</p>
So, the wrong number in the series is 88. <p></p>
</div> </Collapsible>
<br />

<p class="pq">7) What should come in place of the question mark (?) in the following number series:<br/> 
4, 5, 14, 51,  ?</p>
<ol class="pointsu">
<li className='list'>220</li>
<li className='list'>162</li>
<li className='list'>280</li>
<li className='list'>216</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(2)" trigger='Show Answer'> 
<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong></p>
<p>The sequence in the given series is</p>
<p>x 1 + 1<sup>2</sup> = 4 x 1 + 1<sup>2</sup> = 4+1 = 5,<br/>
x 2 + 2<sup>2</sup> = 5 x 2 + 2<sup>2</sup> = 10+4 =  14,<br/>
x 3 +3<sup>2</sup> = 14 x 3 + 3<sup>2</sup>  = 42 + 9 = 51,<br/>
x 4 + 4<sup>2</sup> = 51 x 4 + 4<sup>2</sup> = 204 + 16 = 220</p>
<p>Therefore, the missing number is 220.</p>
</div> </Collapsible>
<br />

<p class="pq">8) Find out the wrong number in the series:<br/>
455, 445, 465, 435, 485, 415,515,455</p>
<ol class="pointsu">
<li className='list'>455</li>
<li className='list'>465</li>
<li className='list'>485</li>
<li className='list'>415</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(3)" trigger='Show Answer'> 
<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong></p>
<p>The given series is made of two different series:</p>
<p>First: 455, 465, 485, 515, and</p>
<p>Second: 445, 435, 415,455</p>
<p>The sequence in first series is + 10, + 20, + 30, and the sequence in second series: -10, -20. So, the number 455 is wrong as it should be 415 - 30 = 385 </p>
</div> </Collapsible>
<br />

<p class="pq">9) 264 &nbsp;&nbsp;&nbsp; 136 &nbsp;&nbsp;&nbsp; 72 &nbsp;&nbsp;&nbsp; 40<br/>
488 &nbsp;&nbsp;&nbsp; (a) &nbsp;&nbsp;&nbsp; (b) &nbsp;&nbsp;&nbsp; (c) &nbsp;&nbsp;&nbsp; (d) &nbsp;&nbsp;&nbsp; (e)</p>
<p class="pq">Which of the following numbers will come in place of (a)?</p>
<ol class="pointsu">
<li className='list'>128</li>
<li className='list'>248</li>
<li className='list'>38</li>
<li className='list'>23</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(4)" trigger='Show Answer'> 
<div id="workspace4"></div>
<div class="testanswer" id="answer4">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong></p>
<p>The given series is ÷ 2 + 4, ÷ 2+4,... 
Therefore the first series is as follows: </p>
<img src="https://static.javatpoint.com/aptitude/images/odd-man-out-and-series-q9.png" alt="Apti Odd Man Out and Series"/>
</div> </Collapsible>
<br />

<p class="pq">10) 2 &nbsp;&nbsp;&nbsp; 17 &nbsp;&nbsp;&nbsp; 121 &nbsp;&nbsp;&nbsp; 729<br/>
5 &nbsp;&nbsp;&nbsp; (a) &nbsp;&nbsp;&nbsp; (b) &nbsp;&nbsp;&nbsp; (c) &nbsp;&nbsp;&nbsp; (d) &nbsp;&nbsp;&nbsp; (e)</p>
<p class="pq">Which of the following numbers will come in place of (b)?</p>
<ol class="pointsu">
<li className='list'>289</li>
<li className='list'>41</li>
<li className='list'>17393</li>
<li className='list'>1448</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(5)" trigger='Show Answer'> 
<div id="workspace5"></div>
<div class="testanswer" id="answer5">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong></p>
<p>The given sequence is</p> 
<p>X * 8 + 1 i.e., 2 * 8 +1 = 16 + 1 = 17<br/>
X * 7 + 2 i.e., 17 * 7 + 2 = 119 + 2 = 121<br/>
X * 6 + 3 i.e., 121 * 6 + 3 = 726 + 3 = 729...</p>
<p>Therefore:</p>
(a)	= 5 X 8 + 1 = 41.<br/>
(b)	= 41 X 7 + 2 = 289.<p></p>
</div> </Collapsible>
<br/>


<p class="pq">11) 8 &nbsp;&nbsp;&nbsp; 8 &nbsp;&nbsp;&nbsp; 12 &nbsp;&nbsp;&nbsp; 24<br/>
36 &nbsp;&nbsp;&nbsp; (a) &nbsp;&nbsp;&nbsp; (b) &nbsp;&nbsp;&nbsp; (c) &nbsp;&nbsp;&nbsp; (d) &nbsp;&nbsp;&nbsp; (e)</p>
<p class="pq">Out of the following numbers which would come in place of (e)?</p>
<ol class="pointsu">
<li className='list'>810</li>
<li className='list'>36</li>
<li className='list'>54</li>
<li className='list'>108</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(1)" trigger='Show Answer'> 
<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong></p>
<p>The series is * 1; * 1.5; * 2 and so on, therefore:</p>
<p>(a)	= 36 X 1  36<br/>
(b)	= 36 x 1.5 = 54<br/>
(c)	= 54 X 2 = 108<br/>
(d)	= 108 X 2.5 = 270<br/>
(e)	= 270 X 3 = 810</p>
</div> </Collapsible>
<br />

<p class="pq">12) Find the wrong number in the series, and then find the third number in the new series?<br/>
3, 5, 12, 38, 154, 914, 4634 </p>
<ol class="pointsu">
<li className='list'>1636</li>
<li className='list'>1222</li>
<li className='list'>1834</li>
<li className='list'>3312</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(2)" trigger='Show Answer'> 
<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong></p>
<p>The series is X * 1 + 2,<br/>
 X * 1 + 2 i.e., 3 * 1 + 2 = 5,<br/>
 X * 2 + 2 i.e., 5 * 2 + 2 = 12,<br/>
 X * 3 + 2 i.e., 12 * 3 + 2 = 38<br/>
 X * 4 + 2 i.e., 38 * 4 + 2 = 154<br/>
 X * 5 + 2 i.e., 154 * 5 + 2 = 772</p>
<p>So, 914 is the wrong number.</p>
<p>Now, starting from 914</p>
<p>Second number = 914 X 1 + 2 = 916</p>
<p>Third number = 916 X 2 + 2 = 1834</p>
<p>Therefore the third number in the new series is 1834. </p>
</div> </Collapsible>
<br />

<p class="pq">13) Find the wrong number in the series, and then find the third number in the series that starts with the wrong number. <br/>
160, 80, 120, 180, 1050, 4725 </p>
<ol class="pointsu">
<li className='list'>60</li>
<li className='list'>90</li>
<li className='list'>3564</li>
<li className='list'>135 </li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(3)" trigger='Show Answer'> 
<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p><strong>Answer:</strong> D</p>
<p><strong>Explanation:</strong></p>
<p>The series is <img src="https://static.javatpoint.com/aptitude/images/odd-man-out-and-series-q13.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Odd Man Out and Series"/></p>
<p>180 is incorrect. In the series beginning with 180<br/>
Second number = 180 x <img src="https://static.javatpoint.com/aptitude/images/odd-man-out-and-series-q13_2.png" style={{margin:'5px 4px -10px 0px'}} alt="Apti Odd Man Out and Series"/>= 90<br/>
Third number = 90 x <img src="https://static.javatpoint.com/aptitude/images/odd-man-out-and-series-q13_3.png" style={{margin:'5px 4px -10px 0px'}} alt="Apti Odd Man Out and Series"/>= 135 </p>
</div> </Collapsible>
<br />

<p class="pq">14) Find out the wrong number in the series, and taking this wrong number as the first term of the second series and following the same logic find out the fourth term of the second series.<br/>
8, 4, 4, 6, 12, 28, 90 </p>
<ol class="pointsu">
<li className='list'>18</li>
<li className='list'>42</li>
<li className='list'>21</li>
<li className='list'>24</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(4)" trigger='Show Answer'> 
<div id="workspace4"></div>
<div class="testanswer" id="answer4">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong></p>
<p>The given series is *<img src="https://static.javatpoint.com/aptitude/images/odd-man-out-and-series-q13_2.png" style={{margin:'5px 4px -10px 0px'}} alt="Apti Odd Man Out and Series"/>,*1,*1 <img src="https://static.javatpoint.com/aptitude/images/odd-man-out-and-series-q13_2.png" style={{margin:'5px 4px -10px 0px'}} alt="Apti Odd Man Out and Series"/>,*2,*2 <img src="https://static.javatpoint.com/aptitude/images/odd-man-out-and-series-q13_2.png" style={{margin:'5px 4px -10px 0px'}} alt="Apti Odd Man Out and Series"/>,*3,</p>
<p>8*0.5=4</p>
<p>4*1= 4</p>
<p>4*1.5=6</p>
<p>6*2=12</p>
<p>12*2.5= 30 </p>
<p>So, 28 is a wrong number. The new series begins with 28. <br/>
So, the second number = 28 x <img src="https://static.javatpoint.com/aptitude/images/odd-man-out-and-series-q13_2.png" style={{margin:'5px 4px -10px 0px'}} alt="Apti Odd Man Out and Series"/>= 14</p>
<p>The third number = 14 x 1 = 14 <br/>
The fourth number = 14 x 1 <img src="https://static.javatpoint.com/aptitude/images/odd-man-out-and-series-q13_2.png" style={{margin:'5px 4px -10px 0px'}} alt="Apti Odd Man Out and Series"/>= 21</p>
</div> </Collapsible>
<br />

<p class="pq">15) Find out the wrong number in the series, and taking this wrong number as the first term of the second series formed, following the same logic, find out the fourth term of the second series.
6, 8, 10, 42, 146, 770, 4578 
</p>
<ol class="pointsu">
<li className='list'>868</li>
<li className='list'>8872</li>
<li className='list'>858</li>
<li className='list'>882</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(5)" trigger='Show Answer'> 
<div id="workspace5"></div>
<div class="testanswer" id="answer5">
<p><strong>Answer:</strong> D</p>
<p><strong>Explanation:</strong></p>
<p>The given series is based on the following pattern:</p>

<p>6 * 1 + 1 * 2 = 8 </p>
<p>8 * 2 - 2 * 3 = 10</p>
<p>10 * 3 + 3 * 4 = 42</p>
<p>42 * 4 - 4 * 5 = 148</p>
<p>148 * 5 + 5 * 6 = 770</p>
<p>770 * 6 - 6 * 7 = 4578</p>
<p>Starting with the wrong number 146, we get </p>
<p>The second number = 146 * 1 + 1 * 2 = 148</p>
<p>The third number = 148 * 2 - 2 * 3 = 290</p>
<p>The fourth number = 290 * 3 + 3 * 4 = 882.</p>
</div> </Collapsible>
<br/>

</td>
        </div>
    )
}

export default Iq2
